import React, { FC } from 'react';
import LoadingKucing from '../../Images/loadingKucingV3.svg';

const LoadingKucingC: FC = () => {
  return (
    <div className="loading-global">
      {
        // eslint-disable-next-line jsx-a11y/alt-text
        <object type="image/svg+xml" data={LoadingKucing} className="img-loader"></object>
      }
    </div>
  );
};

export default LoadingKucingC;
